import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getClaimsSummary } from '../../actions/claims';
import { createFolder, downloadFile, listFiles, removeFile, uploadFile } from "../../actions/files";
import {
    Button,
    MessageCard,
    Theme,
    Loader,
    PDFViewer,
    Container,
    ContentSmall,
    Title,
    i18n,
    tokens,
    Files
} from '@simplybenefits/sb-ui-library';


class ClaimSummary extends Component {
    state = {
        claim: null,
        showFiles: false
    };

    async componentDidMount() {
        const claim = await this.props.dispatch(getClaimsSummary(this.props.match.params.claimID));

        this.setState({
            claim
        });
    }

    _downloadPDF = () => {
        const linkSource = `data:application/pdf;base64,${ this.state.claim.EOB }`;
        const downloadLink = document.createElement("a");
        const fileName = `claim_${ this.state.claim.multilineRefNum || this.state.claim.uid }.pdf`;

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    };

    _toggleFiles = (state) => {
        this.setState({
            showFiles: state
        });
    }

    render() {
        const { whitelabel } = this.props;

        const styles = {
            displayContainer: {
                display: 'flex',
                justifyContent: 'center',
                width: '50%',
                minWidth: 800,
                marginLeft: 'auto',
                marginRight: 'auto'
            },
            downloadBtnContainer: {
                display: 'flex',
                flex: 1,
                justifyContent: 'center',
                marginBottom: 10
            },
            receipt: {
                display: 'block',
                marginLeft: 'auto',
                marginRight: 'auto',
                width: '500px',
                height: 'auto',
                boxShadow: '0 10px 40px rgba(0, 0, 0, 0.7)',
                marginBottom: 50,
                zIndex: 1000
            }
        };

        if (!this.state.claim || this.props.loading) {
            return (
                <Loader whitelabel={ whitelabel } />
            );
        }

        if ([ 'approved', 'declined', 'paid' ].includes(this.state.claim.status.toLowerCase())) {
            return (
                <Container>
                    <div style={ styles.downloadBtnContainer }>
                        {
                            this.state.showFiles ?
                                <>
                                    <Button transparent onClick={ () => this._toggleFiles(false) }>
                                        { i18n.t(tokens.buttons.viewEOB) }
                                    </Button>

                                    <span style={{
                                        color: Theme.colors.darkBlue,
                                        lineHeight: 2
                                    }}>|</span>

                                    <Button transparent onClick={ this._downloadPDF }>
                                        { i18n.t(tokens.buttons.downloadEOB) }
                                    </Button>
                                </>
                                :
                                <>
                                    <Button transparent onClick={ () => this._toggleFiles(true) }>
                                        { i18n.t(tokens.buttons.viewFiles) }
                                        { i18n.t(tokens.buttons.viewFiles) }
                                        { i18n.t(tokens.buttons.viewFiles) }
                                    </Button>

                                    <span style={{
                                        color: Theme.colors.darkBlue,
                                        lineHeight: 2
                                    }}>|</span>

                                    <Button transparent onClick={ this._downloadPDF }>
                                        { i18n.t(tokens.buttons.downloadEOB) }
                                    </Button>
                                </>
                        }
                    </div>

                    <div style={ styles.displayContainer }>
                        {
                            this.state.showFiles ?
                                <Files
                                    type="users"
                                    id={ this.props.user.userID }
                                    parentFolder={ `claims/${ this.props.match.params.claimID }/files` }
                                    dispatch={ this.props.dispatch }
                                    listFiles={ listFiles }
                                    createFolder={ createFolder }
                                    uploadFile={ uploadFile }
                                    downloadFile={ downloadFile }
                                    removeFile={ removeFile }
                                    isLocked={ ![ 'PENDING', 'INCOMPLETE' ].includes(this.state.claim.status.toUpperCase()) }
                                />
                                :
                                <PDFViewer pdf={ `data:image/png;base64,${ this.state.claim.EOB }`}/>
                        }
                    </div>

                    <span id="claimSummary" />
                </Container>
            );
        }

        return (
            <Container>
                <ContentSmall style={{ width: "60%" }}>
                    <Title title={ i18n.t(tokens.titles["claim summary"])} />

                    <MessageCard
                        title={ i18n.t(tokens.titles["claim pending"])}
                        subtitle={ i18n.t(tokens.labels.claims.claimStatusMessage) }
                        small
                    />

                    <Files
                        type="users"
                        id={ this.props.user.userID }
                        parentFolder={ `claims/${ this.props.match.params.claimID }/files` }
                        dispatch={ this.props.dispatch }
                        listFiles={ listFiles }
                        createFolder={ createFolder }
                        uploadFile={ uploadFile }
                        downloadFile={ downloadFile }
                        removeFile={ removeFile }
                        isLocked={ ![ 'PENDING', 'INCOMPLETE' ].includes(this.state.claim.status.toUpperCase()) }
                    />
                </ContentSmall>
            </Container>
        );
    }
}


ClaimSummary.propTypes = {
    loading: PropTypes.bool,
    user: PropTypes.object,
    whitelabel: PropTypes.object
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    loading: state.claims.loading,
    user: state.user.meta,
    whitelabel: state.whitelabel
});

export default connect(mapStateToProps)(ClaimSummary);